@if (user()) {
  <div animate.enter="fade-in" class="side-top" [class.expanded]="expanded()">
    <div class="side-top__header">
      <!-- Mobile only: Vault Mode button in header -->
      <div class="side-top__mode-mobile">
        <span>{{ user()?.type === 0 ? "Fight" : "Vault" }} Mode</span>
      </div>
      <button class="side-top__toggle" (click)="toggleExpanded()">
        <svg-icon
          src="assets/icons/king-new/chevron-down.svg"
          [class.rotated]="expanded()"
        ></svg-icon>
      </button>
    </div>
    <div class="side-top__collapsible">
      @if (!isChallenger()) {
        <div animate.enter="fade-in" class="side-top__modes">
          <button [class.active]="!vault()" (click)="toggleVault(false)">
            King's items
          </button>
          <button [class.active]="vault()" (click)="toggleVault(true)">
            King's vault
          </button>
        </div>
      }
      <div class="side-top__values">
        <div class="side-top__values--items">
          <svg-icon
            src="assets/icons/king-new/items-box.svg"
          ></svg-icon>
          <span typography>
          {{ kingSkins().length }}
        </span>
        </div>
        <div class="side-top__values--price">
          <app-cost
            color="var(--red)"
            [cost]="skinsValue()"
            [balanceType]="'skins'"
          />
        </div>
        <!-- Desktop only: Vault Mode button -->
        <div class="side-top__values--mode">
          <span>{{ user()?.type === 0 ? "Fight" : "Vault" }} Mode</span>
        </div>
      </div>
    </div>
  </div>
  <app-skins-list
    class="skins"
    [skins]="kingSkins()"
    [config]="{
    skin_min_width: '120px',
    mobile: {
      padding: '10px',
      skin_min_width: '90px',
    },
  }"
  />
} @else {
  <button animate.enter="fade-in" class="placeholder" (click)="openModal()">
    <p>
      {{
        isChallenger()
          ? "Challenge the Reigning King to take what's rightfully yours!"
          : "Become the King and defend your Glory!... and your skins"
      }}
    </p>
    <img
      [alt]="isChallenger() ? 'challenger' : 'king'"
      [src]="
        isChallenger()
          ? 'assets/icons/king-new/challenger.png'
          : 'assets/icons/king-new/king.png'
      "
      loading="lazy"
    />
  </button>
}
